import angular from 'angular';

angular.module('cloudX').directive('assignmentsEnabled', [
  'dataCache',
  function(dataCache) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        dataCache.ready().then(function() {
          const enabled = dataCache.getArray('assignmentsEnabled');
          if (!enabled) element.remove();
        });
      },
    };
  },
]);
